// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"31d6cfe0","301":"9bc0cc78","341":"b4129c3e","422":"d94349dc","610":"92d2fc6f","823":"1ccc0d28","884":"fb41c940","950":"3fcc89fe"}[chunkId] + ".chunk.css";
};